import {
    Box,
    Step,
    StepLabel,
    Stepper as RawStepper,
    styled,
    IconButton,
} from '@mui/material'
import {forgotPasswordStepsComponents} from 'constants/auth'
import {useI18n} from 'store/Store'
import Card from 'components/Display/Card'
import EastIcon from '@mui/icons-material/East'
import {FormProvider} from 'react-hook-form'
import {LoadingButton} from '@mui/lab'
import {Texts} from 'appearance'
import RegisterSuccess from 'components/Auth/Register/RegisterSuccess'
import useForgotPasswordScreen from 'logic/screens/useForgotPasswordScreen'
import {useDeviceDetect} from 'services/hooks'

const ForgotPassword = () => {
    const {i18n} = useI18n()
    const {isMobile} = useDeviceDetect()

    const {
        generalError,
        forgotPasswordSteps,
        onDone,
        handleBack,
        handleNext,
        isLoadingVerifySms,
        forgotPasswordResponse,
        forgotPassword,
        activeStep,
        methods,
        buttonText,
    } = useForgotPasswordScreen()

    const StepComponent =
        forgotPasswordStepsComponents[forgotPasswordSteps[activeStep]]

    return (
        <Container isMobile={isMobile}>
            <Stepper activeStep={activeStep} alternativeLabel={isMobile}>
                {forgotPasswordSteps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{i18n.t(`register.${label}`)}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            <StepContnet
                isMobile={isMobile}
                contentStyle={{
                    display: 'flex',
                    height: '100%',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    boxSizing: 'border-box',
                }}>
                {forgotPasswordResponse ? (
                    <RegisterSuccess onDone={onDone} />
                ) : (
                    <FormProvider {...methods}>
                        <>
                            {!!generalError && (
                                <GeneralError>{generalError}</GeneralError>
                            )}

                            <BackButton
                                disableRipple
                                sx={{
                                    display:
                                        activeStep === 0 ? 'none' : 'block',
                                }}
                                onClick={handleBack}>
                                <EastIcon fontSize="large" />
                            </BackButton>

                            <StepComponent />

                            <StepperButtons>
                                <LoadingButton
                                    size="small"
                                    onClick={
                                        activeStep === 2
                                            ? forgotPassword
                                            : handleNext
                                    }
                                    loading={isLoadingVerifySms}
                                    variant="contained"
                                    color="secondary">
                                    {i18n.t(`register.${buttonText}`)}
                                </LoadingButton>
                            </StepperButtons>
                        </>
                    </FormProvider>
                )}
            </StepContnet>
        </Container>
    )
}

export default ForgotPassword

const Container = styled(Box)`
    background: #f5f5f5;
    width: auto;
    padding: ${({isMobile}) => (isMobile ? 20 : 130)}px;
    height: 100vh;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
`

const Stepper = styled(RawStepper)`
    direction: rtl;
    & .MuiStepLabel-iconContainer {
        padding-inline: 8px;
    }

    & .MuiStepConnector-root {
        left: calc(50% + 20px);
        right: calc(-50% + 20px);
    }
`

const StepContnet = styled(Card)`
    width: 100%;
    flex: 1;
    margin-top: ${({isMobile}) => (isMobile ? 20 : 100)}px;
    display: flex;
    flex-direction: column;
    & .MuiCardContent-root {
        flex: 1;
    }
`

const StepperButtons = styled(Box)`
    display: flex;
    justify-content: space-between;
    margin-top: auto;
`

const BackButton = styled(IconButton)`
    display: block;
    align-self: end;
`

const GeneralError = styled(Texts.RegularText)`
    color: red;
    font-size: 16px;
    text-align: center;
`
